document.addEventListener("DOMContentLoaded", function () {

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function setCookie(name, value, days) {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${value}; expires=${expires}; path=/`;
    }

    // Only proceed if cookie is not already set
    if (!getCookie("geo_popup_shown")) {
      fetch('https://get.geojs.io/v1/ip/geo.json')
        .then(response => response.json())
        .then(data => {
          const userCountry = data.country;

          const middleEastCountries = [
            "United Arab Emirates", "Saudi Arabia", "Qatar",
            "Oman", "Bahrain", "Kuwait", "Jordan",
            "Lebanon", "Iraq", "Yemen", "Syria", "Palestine"
          ];

          if (middleEastCountries.includes(userCountry)) {
            showGeoPopup();
            setCookie("geo_popup_shown", "true", 1); // Store for 1 day
          }
        })
        .catch(error => console.error("Geolocation error:", error));
    }

    function showGeoPopup() {
      const popup = document.createElement("div");
      popup.style.position = "fixed";
      popup.style.top = "0";
      popup.style.left = "0";
      popup.style.width = "100%";
      popup.style.height = "100%";
      popup.style.background = "rgba(0, 0, 0, 0.6)";
      popup.style.display = "flex";
      popup.style.justifyContent = "center";
      popup.style.alignItems = "center";
      popup.style.zIndex = "9999";

      popup.innerHTML = `
        <div style="background: #fff; padding: 32px; max-width: 480px; width: 90%; text-align: center;  position: relative; font-family: sans-serif;">
          <button onclick="this.closest('div').parentElement.remove()" style="position: absolute; top: 10px; right: 15px; background: none; border: none; font-size: 20px !important; cursor: pointer;">&times;</button>
          <h2 style="margin-bottom: 10px; color:black; font-size:15px !important; letter-spacing:0.8px;">HELLO,</h2>
          
          <button style="border: 2px solid black; background: white; color: black; margin-bottom: 12px;  padding: 12px 24px; width: 100%; cursor: pointer; letter-spacing:0.8px; "
           onclick="document.querySelector('.geo-popup').remove();">
            YES, STAY ON THESE
          </button>

          <button style="background: black; color: white;  padding: 12px 24px; border: none; width: 100%; cursor: pointer; letter-spacing:0.8px;"
            onclick="window.location.href='https://me.thehouseofrare.com/';">
            NO, CONTINUE ON Middle-East
          </button>

        </div>
      `;
      popup.classList.add('geo-popup');
      document.body.appendChild(popup);
       const styleTag = document.createElement("style");
  styleTag.innerHTML = `
    @media (max-width: 768px) {
      .geo-popup * {
        font-size: 10px !important;
      }
      .geo-popup h2 {
        font-size: 15px !important;
      }
    }
  `;
  document.head.appendChild(styleTag);
    }
  });